import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import ExploreLayout from '../layouts/explore_layout'

class ExplorePage extends React.PureComponent {

  render() {
    const { children, title, noRightSidebar } = this.props

    return (
      <ExploreLayout noRightSidebar={noRightSidebar} title={title}>
        <PageTitle path={title} />
        {children}
      </ExploreLayout>
    )
  }

}

ExplorePage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  noRightSidebar: PropTypes.bool,
}

export default ExplorePage